import { useEffect, useState } from 'react';

import { useAuthData } from '../../../../../../hooks';

export const useIsTokenValid = (): boolean => {
  const tokens = useAuthData();
  const expiresAt = tokens?.expiresAt;

  // Only used to force a re-render at the moment the token expires while the app
  // sits idle, so consumers recompute from valid to invalid. Validity itself is
  // derived synchronously below.
  const [, setExpiryTick] = useState(0);

  useEffect(() => {
    if (!expiresAt) return undefined;

    const timeToExpire = new Date(expiresAt).getTime() - Date.now();
    if (timeToExpire <= 0) return undefined;

    const timerId = setTimeout(
      () => setExpiryTick((tick) => tick + 1),
      timeToExpire,
    );

    return () => clearTimeout(timerId);
  }, [expiresAt]);

  // Derived synchronously from the timestamp so there is no one-render lag after
  // tokens are set/cleared (a lag would momentarily read a fresh valid token as
  // invalid, e.g. flashing the "already logged in" guard during a normal login).
  if (!expiresAt) return false;

  return new Date(expiresAt).getTime() > Date.now();
};
